import React, { useState } from "react";
import { connect } from "react-redux";
import ValidationInputsWithRadio from "../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio";
import { Col, Row, Container, Input } from "reactstrap";
import BtnSubmit from "../../Shared/Buttons/BtnSubmit";
import BtnWhite from "../../Shared/Buttons/BtnWhite";
import {
  ChangeSim,
  setIsShowPopup,
  reportDWH,
} from "../PortalsBlock/portalSlice";
import { showAppLoader, hideAppLoader } from "../../Shared/Loader/LoaderSlice";
import ChangeHetPayPopUp from "../ClientInformationBlock/ChangeHetPayPopUp";
import PopUp from "../../Shared/Popup/PopUp";
import { useEffect } from "react";
import SimChangeSuccessPopUp from "./SimChangeSuccessPopUp";
import SimChangeErrorPopUp from "./SimChangeErrorPopUp";
import { isMobile } from "react-device-detect";
import EpiContext from "@episerver/spa-core/Spa";
import Config from "../../../Config";
import { reportDWHBuilder } from "./reportDWH";
import { gtag4 } from "../../../utilities/analytics/tracking";

export const BusinessClientSimChangeMain = (props) => {
  useEffect(() => {
    if (!oldHetPay.id) {
      getOldHetPayName();
    }
    reportDWH("SHOWPAGE", { param1: props.portalState.selectedHetPay });
    gtag4({
      event: "SimReplacement_FormImp",
      action: "FormImp",
    });
  }, []);

  const reportDWH = (mode, params) => {
    const report = reportDWHBuilder(mode, params);
    props.reportDWH(report);
  };
  const form = [
    {
      inputName: "מספר טלפון",
      id: 1,
      formType: "PHONE",
      pattern: "[0-9]*",
      maxLength: "10",
      regexPattern: "^[0-9]{10}$",
    },
     {
      inputName: "מספר סים נוכחי",
      id: 3,
      formType: "SIM",
      pattern: "[0-9]*",
      maxLength: "18",
      regexPattern: "^[0-9]{18}$",
      inputText: "סים קיים",
    },
    {
      inputName: "מספר סים",
      id: 2,
      formType: "SIM",
      pattern: "[0-9]*",
      maxLength: "18",
      regexPattern: "^[0-9]{18}$",
      inputText: "הזן סים חדש לשינוי",
    },
  ];
  const [formType, setFormType] = useState({
    id: "",
    formType: "",
  });
  const [typedNumber, setTypedNumber] = useState({ id: null, value: "" });
  const [phoneNumber, setPhoneNumber] = useState({ id: null, value: props.subscriberNumber ?? "" });
  const [newSimNumber, setNewSimNumber] = useState({ id: null, value: "" });

  const onChange = (id, value) => {
    if (id === 1) {
      setPhoneNumber({
        id: id,
        value: value,
      });
    } else if (id === 2) {
      setNewSimNumber({
        id: id,
        value: value,
      });
    }
  };

  const getValue = (id) => {
    if (id === 1) return phoneNumber.value;
    else if (id === 2) return newSimNumber.value;
  };

  const radioButtonClick = (id, formType) => {
    setFormType({
      id: id,
      formType: formType,
    });
    if (typedNumber.value) {
      setTypedNumber((state) => {
        return {
          id: null,
          value: "",
        };
      });
    }
  };

  const [isAllowed, setIsAllowed] = useState({
    description: "initialState",
    isAllowed: false,
  });
  const [data, setData] = useState();

  let isValidPhoneNumber = false;
  let isValidSimNumber = false;
  const patternTest = () => {
    isValidPhoneNumber = new RegExp(form[0].regexPattern).test(
      phoneNumber.value,
    );
    isValidSimNumber = new RegExp(form[1].regexPattern).test(
      newSimNumber.value,
    );

    if (isValidPhoneNumber && isValidSimNumber) {
      return true;
    } else {
      return false;
    }
  };

  const changeSim = async () => {
    props.showAppLoader();

    let orgId;
    reportDWH("BUTTON_CLICK", {
      param10: phoneNumber.value,
      param2: newSimNumber.value,
      param1: props.portalState.selectedHetPay,
    });
    gtag4({
      event: "SimReplacement_ContimueButton",
      button: "המשך",
      action: "ContinueButton",
    });
    props.portalState?.privateCompanyList.map((company) => {
      if (company.idNumber === props.portalState?.selectedHetPay) {
        return (orgId = company.orgId);
      }
    });
    if (isAllowed?.newOrgId) {
      orgId = isAllowed?.newOrgId;
    }
    const result = await props.ChangeSim({
      orgId: orgId,
      phoneNumber: phoneNumber.value,
      newSimNumber: newSimNumber.value,
    });
    if (result.payload.error) {
      props.hideAppLoader();
      reportDWH("GEN_ERR", {
        param10: phoneNumber.value,
        param2: newSimNumber.value,
        param1: props.portalState.selectedHetPay,
      });
      return setIsAllowed(result.payload);
    }
    setIsAllowed({
      isAllowed: result.payload.isAllowed,
      description: result.payload.description,
      newOrgId: result.payload.newOrgIdNumber,
      newOrgName: result.payload.newOrgName,
    });
    if (
      result.payload.description === "MemberOfDifferentOrg" ||
      result.payload.description === "OrgIdNotFound"
    ) {
      props.setIsShowPopup(true);
      reportDWH("SUB_DIFF_ORG", {
        param10: phoneNumber.value,
        param2: newSimNumber.value,
        param1: props.portalState.selectedHetPay,
      });
    } else if (result.payload.simChangeSuccess) {
      reportDWH("SUCCESS", {
        param10: phoneNumber.value,
        param2: newSimNumber.value,
        param1: props.portalState.selectedHetPay,
        businessDetails: {_subscriber: phoneNumber.value ,'מספר סים': newSimNumber.value},
      });
      props.setIsShowPopup(true);
      gtag4({
        event: "SimReplacement_SuccessPage",
        action: "SuccessPage",
      });
    } else if (result.payload.description === "PhoneNumberNotFound") {
      reportDWH("SUB_NOT_FOUND", {
        param10: phoneNumber.value,
        param2: newSimNumber.value,
        param1: props.portalState.selectedHetPay,
      });
    } else {
      props.setIsShowPopup(true);
      reportDWH("GEN_ERR", {
        param10: phoneNumber.value,
        param2: newSimNumber.value,
        param1: props.portalState.selectedHetPay,
      });
      gtag4({
        event: "UpdateSubscriberInfo_ErrorMessage",
        error: `לקוח יקר, לא ניתן להתקדם בתהליך, נא פנה לאחראי/ת שירות להמשך טיפול.`,
        action: "ErrorMessage",
      });
    }

    setData(result.payload);
    props.hideAppLoader();
  };

  const [oldHetPay, setOldHetPay] = useState({
    id: "",
    name: "",
  });

  const getOldHetPayName = () => {
    props.portalState?.hetPaysNumbers?.map((h) => {
      if (h.id === props.portalState.selectedHetPay)
        setOldHetPay({
          id: h.id,
          name: h.name,
        });
    });
  };
  const onPopupClosing = () => {
    props.setIsShowPopup(false);
    setIsAllowed({
      description: "initialState",
    });
    return props.isShowPopup;
  };

  const getCustomerValidationErrorDescription = () => {
    let error;
    if (isAllowed.description == "PhoneNumberNotFound") {
      error = `לא נמצא מנוי, אנא בדקו את הפרטים שהוזנו`;
    } else if (isAllowed.description == "AccountNotFound") {
      error = `מנוי זה לא משוייך לאחד מהארגונים שלך, אנא בדקו את הפרטים שהוזנו`;
    } else if (isAllowed.description == "MemberOfDifferentOrg") {
      error = `מנוי זה משוייך לארגון אחר מרשימת הארגונים שלך, אנא בדקו את הפרטים שהוזנו`;
    } else if (
      isAllowed.description == "ErrorOnValidation" ||
      isAllowed.description == "Unknown" ||
      isAllowed.error
    ) {
      error = `קרתה תקלה במהלך הזיהוי, אנא בדקו את הפרטים שהוזנו`;
    }
    return error;
  };

  const getButtonModes = () => {
    if (isAllowed.description === "initialState") {
      return (
        <>
          <Row className="justify-content-center mt-5">
            <Col
              xs="12"
              className={`btn-220 btn-row pr-0 pl-0 text-center ${
                !patternTest() && "disabled-btn"
              }`}
            >
              <BtnSubmit isBusiness text={`המשך`} onclick={() => changeSim()} />
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col xs="12" className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite
                isBusiness
                text={`חזרה לאיזור האישי`}
                onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)}
              />
            </Col>
          </Row>
        </>
      );
    } else if (
      (isAllowed.isAllowed == false || isAllowed.error) &&
      isAllowed.description !== "MemberOfDifferentOrg"
    ) {
      return (
        <>
          <Row className="account-denied text-center  mt-2">
            <Col xs="12" className="justify-content-center pr-0 pl-0">
              <p className="font-14 newPurple-text mb-1">
                {getCustomerValidationErrorDescription()}
              </p>
            </Col>
            <Col xs="12" className="justify-content-center pr-0 pl-0">
              {isMobile ? (
                <a href={`tel:${window.Config.businessCallNumber}`} className="font-14 bold asBtn">
                  אחרת חייג 234* לשיחה עם צוותון שירות
                </a>
              ) : (
                <p className="font-14 bold mb-0">
                  חיוג 234* לשיחה עם צוותון שירות
                </p>
              )}
            </Col>
          </Row>
          <Row className="justify-content-center mt-3">
            <Col
              xs="12"
              className={`btn-220 btn-row pr-0 pl-0 text-center ${
                !patternTest() ? "disabled-btn" : ""
              }`}
            >
              <BtnSubmit
                isBusiness
                text={`נסה שוב`}
                onclick={() => changeSim()}
              />
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col xs="12" className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite
                isBusiness
                text={`חזרה לאיזור האישי`}
                onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)}
              />
            </Col>
          </Row>
        </>
      );
    }
  };

  return (
    <div className="business-client-sim-change">
      <ValidationInputsWithRadio
        form={form}
        formType={formType}
        setTypedNumber={setTypedNumber}
        typedNumber={typedNumber}
        radioButtonClick={radioButtonClick}
        getButtonModes={getButtonModes}
        title={props?.iContent?.title?.value || props.pageTitle}
        boldTitle={props?.iContent?.boldTitle?.value || props.pageSubtitle}
        isRadio={false}
        onChange={onChange}
        getValue={getValue}
        subscriberNumberAsValue={props.subscriberNumber}
        simSerialNumber={props.simSerialNumber}
      />
      {!isAllowed?.isAllowed ? (
        <PopUp
          showPopUp={props.portalState.isShowPopup}
          onClose={() => onPopupClosing()}
        >
          <ChangeHetPayPopUp
            isAllowed={isAllowed}
            setIsAllowed={setIsAllowed}
            oldHetPay={oldHetPay}
            setIsShowPopup={props.setIsShowPopup}
            btnText={"המשך להחלפת סים"}
            onButtonClick={changeSim}
          />
        </PopUp>
      ) : (
        <PopUp
          preventWrapperClose={false}
          showPopUp={props.portalState.isShowPopup}
          onClose={() => onPopupClosing()}
        >
          {data?.simChangeSuccess ? (
            <SimChangeSuccessPopUp
              setIsShowPopup={props.setIsShowPopup}
              phoneNumber={phoneNumber.value}
            />
          ) : (
            <SimChangeErrorPopUp
              setIsShowPopup={props.setIsShowPopup}
              isSimEqual={
                data?.newSimDeniedDescription === "NewSimIsEqualToOldSim"
                  ? true
                  : false
              }
            />
          )}
        </PopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  portalState: state.portalsBlock,
  simSerialNumber:
      state.BusinessClientEsimUpgradeSlice?.esimPriceApiResponse
        ?.simSerialNumber,
});

const mapDispatchToProps = {
  ChangeSim,
  hideAppLoader,
  showAppLoader,
  setIsShowPopup,
  reportDWH,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessClientSimChangeMain);
